module.exports = __webpack_public_path__ + "img/ow-logo.42b04ef8.svg";